import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgDelete = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99984 1.66669C5.3915 1.66669 1.6665 5.39169 1.6665 10C1.6665 14.6084 5.3915 18.3334 9.99984 18.3334C14.6082 18.3334 18.3332 14.6084 18.3332 10C18.3332 5.39169 14.6082 1.66669 9.99984 1.66669ZM14.1665 12.9917L12.9915 14.1667L9.99984 11.175L7.00817 14.1667L5.83317 12.9917L8.82484 10L5.83317 7.00835L7.00817 5.83335L9.99984 8.82502L12.9915 5.83335L14.1665 7.00835L11.1748 10L14.1665 12.9917Z"
      fill="#DC362E"
    />
  </svg>
);

export default SvgDelete;
